import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation, listVals } from "../../common/validation.common";
import { DismantleStatusEnum } from "../../data/enums";

export namespace SubscriptionDismantleValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.array(v.picklist(DismantleStatusEnum.values))),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            customerId: baseVals.string(),
            subscriptionId: baseVals.string(),
        }),
    );

    export const DismantleSetup = defineValidation(
        v.object({
            priority: baseVals.intRange(1, 10, "Prioritas"),
        }),
    );

    export const Update = defineValidation(
        v.object({
            priority: v.exactOptional(baseVals.intRange(1, 10, "Prioritas")),
            dismantleData: v.exactOptional(
                v.object({
                    schedule: v.optional(baseVals.isoDate("Jadwal Pelepasan")),
                    supervisorId: v.optional(baseVals.string()),
                    technicianIds: v.optional(listVals.stringList("Pelaksana")),
                    ccIds: v.optional(listVals.stringListEmptiable()),
                    notes: v.optional(baseVals.stringEmptiable()),
                }),
            ),
        }),
    );

    export const DismantleCreate = defineValidation(
        v.object({
            schedule: baseVals.isoDate("Jadwal Pelepasan"),
            supervisorId: baseVals.string(),
            technicianIds: listVals.stringList("Pelaksana"),
            ccIds: v.optional(listVals.stringListEmptiable()),
        }),
    );

    export const DismantleReport = defineValidation(
        v.object({
            notes: v.optional(baseVals.stringEmptiable()),
        }),
    );

    export const Finalize = defineValidation(
        v.object({
            customerSign: baseVals.string(),
            supervisorSign: baseVals.string(),
            deleteCustomer: v.boolean(),
        }),
    );
}
